import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=2cdab762&scoped=true"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"
import style0 from "./registration.vue?vue&type=style&index=0&id=2cdab762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdab762",
  null
  
)

export default component.exports